const Listing = [
  {
    id: 1,
    image: '',
    name: 'Business',
    quotes: 'Card Qutotation for Business.',
  },
  {
    id: 2,
    image: '',
    name: 'Investor',
    quotes: 'Card Qutotation for Investor.',
  },
  {
    id: 3,
    image: '',
    name: 'Mentor',
    quotes: 'Card Qutotation for Mentor.',
  },
  {
    id: 4,
    image: '',
    name: 'Startup',
    quotes: 'Card Qutotation for Startup.',
  },
  {
    id: 5,
    image: '',
    name: 'Lender',
    quotes: 'Card Qutotation for Lender.',
  },
  {
    id: 6,
    image: '',
    name: 'Franchise',
    quotes: 'Card Qutotation for Franchise.',
  },
];

export default Listing;
